export const SET_ACTION_TRIGGERED = 'SET_ACTION_TRIGGERED';